export const sliceStringIntoLines = (
  str: string,
  maxLength: number,
): string[] => {
  if (str.length === 0) {
    return [];
  }
  return str.split(' ').reduce((acc: string[], word) => {
    // If the accumulator is empty or adding the new word exceeds maxLength, create a new line
    if (
      acc.length === 0 ||
      acc[acc.length - 1].length + word.length + 1 > maxLength
    ) {
      // If it's the first word, just add it without a preceding space
      acc.push(word);
    } else {
      // Otherwise, add the word to the last line with a space
      acc[acc.length - 1] += ` ${word}`;
    }

    return acc;
  }, []);
};
